import React from 'react'
import { IssuingCard } from './IssuingCard'

export const IssuingAddCard = () => {
  return (
    <IssuingCard />
  )
}
